module.exports = __webpack_public_path__ + "static/media/reward5.a62defee.jpg";